import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import IncidentTable from './IncidentTable';
import { SelectIncidentConfiguration, ToggleIncConfigDialog } from '../../../actions/IncidentTrackerConfigurationActions.js';

const IncidentPriorityTable = (props) => {
	const { className, data, ...rest } = props;
	const dispatch = useDispatch();

	const _incConfigDialogOpen = (rowData, mode) => {
		const item = { id: rowData[0], priority: rowData[1] };
		dispatch(SelectIncidentConfiguration({ category: 'priority', item }));
		dispatch(ToggleIncConfigDialog(true, mode));
	};

	const _getTableColumns = () => (
		[
			{
				name: 'priority',
				label: 'Priority',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
		]
	);

	return (
		<IncidentTable
			identifier="incidentPriorityTable"
			title="Priority"
			data={data}
			customColumns={_getTableColumns()}
			onEditClick={(rowData) => _incConfigDialogOpen(rowData, 'Update')}
			onDeleteClick={(rowData) => _incConfigDialogOpen(rowData, 'Delete')}
		/>
	);
};

IncidentPriorityTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default IncidentPriorityTable;
